import * as PracticeAreasFeatures01Uploads from "$lib/data/generated/uploads/practice areas/Features 01/uploads.js";
import * as PracticeAreasFeaturesPracticeAreasUploads from "$lib/data/generated/uploads/practice areas/Features Practice Areas/uploads.js";
import * as PracticeAreasFeaturesYourRightsUploads from "$lib/data/generated/uploads/practice areas/Features Your Rights/uploads.js";
import * as PracticeAreasPageBannerUploads from "$lib/data/generated/uploads/practice areas/PageBanner/uploads.js";
import * as PracticeAreasPracticeAreasUploads from "$lib/data/generated/uploads/practice areas/PracticeAreas/uploads.js";
import * as PracticeAreasSideBySideUploads from "$lib/data/generated/uploads/practice areas/SideBySide/uploads.js";

export const uploads = {
  ...PracticeAreasFeatures01Uploads.uploads,
  ...PracticeAreasFeaturesPracticeAreasUploads.uploads,
  ...PracticeAreasFeaturesYourRightsUploads.uploads,
  ...PracticeAreasPageBannerUploads.uploads,
  ...PracticeAreasPracticeAreasUploads.uploads,
  ...PracticeAreasSideBySideUploads.uploads
};
